"use client";

import { usePathname } from "next/navigation";

import { routes } from "#/config/routes";
import { usePerpInstrumentName } from "#/hooks/usePerpInstrumentName";
import { useLastTradesByInstrument as useLastTradesByInstrumentQuery } from "#/services/kyan/hooks/useLastTradesByInstrument";
import { useLastTradesByInstrument } from "#/store/app/lastTrades/lastTrades";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";
import { getPerpInstrumentProperties } from "#/utils/instrument.utils";

import { useRealtimeLastTradesFeatureFlag } from "./featureFlags/useRealtimeLastTradesFeatureFlag";

export const useLastPerpTradesByInstrument = (instrumentName?: string) => {
  const { isRealtimeLastTradesEnabled } = useRealtimeLastTradesFeatureFlag();
  const { perpInstrumentName } = usePerpInstrumentName();
  const pathname = usePathname();
  const isOnPerpsPage = pathname.startsWith(routes.perps);
  const { showTradePanel } = useShowTradePanel();

  const {
    data,
    isLoading: isLoadingQuery,
    refetch,
  } = useLastTradesByInstrumentQuery({
    instrument_name: instrumentName ?? perpInstrumentName,
    count: 100,
    disabled: !isOnPerpsPage && !showTradePanel,
  });
  const { trades, isLoading: isLoadingWs } = useLastTradesByInstrument(
    instrumentName ?? perpInstrumentName,
  );
  const lastTrades = isRealtimeLastTradesEnabled ? trades : data;
  const underlying = getPerpInstrumentProperties(
    instrumentName ?? perpInstrumentName,
  ).underlying;

  return {
    lastTrades,
    lastTrade: lastTrades?.[0],
    isLoading: isRealtimeLastTradesEnabled ? isLoadingWs : isLoadingQuery,
    underlying,
    refetch: isRealtimeLastTradesEnabled ? null : refetch,
  };
};
